module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_6.0b14fd49.jpg";